import ToolTip from "uis/new-tootip";
import {
  Container,
  UpperSection,
  TopSection,
  Title,
  TabSection,
  Tab,
  TabBar,
} from "./MinimumAttendeesManagementPage.styles";
import UI from "@mile-meeting/mile-ui";
import { useState } from "react";

import ViolationReservations from "./ViolationReservations/ViolationReservations";
import MinimumAttendeesSetting from "./MinimumAttendeesSetting/MinimumAttendeesSetting";

const MinimumAttendeesManagement: React.FC = () => {
  enum ETab {
    MINIMUM_ATTENDEES_SETTING,
    VIOLATION_RESERVATION,
  }

  const [selectedTab, setSelectedTab] = useState<ETab>(ETab.MINIMUM_ATTENDEES_SETTING);
  return (
    <Container>
      <TopSection>
        <UpperSection>
          <Title>
            <UI.Typography type="title03" fontStyle="bold" color="var(--alias-color-label-neutral)">
              최소 참석 인원 관리
            </UI.Typography>
            <ToolTip
              text={"인원 제한에도 불구하고 필수로 진행되어야 하는 회의는 마일에서 예약 시, 예외 적용이 가능합니다."}
              icon={"info"}
              position={{
                top: 28,
                left: -182,
              }}
            />
          </Title>
          <TabSection>
            <TabBar>
              <Tab
                selected={selectedTab === ETab.MINIMUM_ATTENDEES_SETTING}
                onClick={() => setSelectedTab(ETab.MINIMUM_ATTENDEES_SETTING)}
              >
                최소 참석 인원 설정
              </Tab>
              <Tab
                selected={selectedTab === ETab.VIOLATION_RESERVATION}
                onClick={() => setSelectedTab(ETab.VIOLATION_RESERVATION)}
              >
                위반 예약 조회
              </Tab>
            </TabBar>
          </TabSection>
        </UpperSection>
        <MinimumAttendeesSetting isShow={selectedTab === ETab.MINIMUM_ATTENDEES_SETTING} />
        <ViolationReservations isShow={selectedTab === ETab.VIOLATION_RESERVATION} />
      </TopSection>
    </Container>
  );
};

export default MinimumAttendeesManagement;
